function Connect() {
    return <w3m-button size="md" label="Connect" />
}

export default Connect
